var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgYoutube = function SvgYoutube(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "m19.044 30.27-.002-13.582 12.97 6.814-12.968 6.768ZM47.52 14.334s-.47-3.33-1.908-4.798c-1.826-1.926-3.871-1.935-4.809-2.047C34.086 7 24.011 7 24.011 7h-.022s-10.075 0-16.792.49c-.939.111-2.983.12-4.81 2.046C.948 11.003.48 14.334.48 14.334S0 18.247 0 22.158v3.668c0 3.912.48 7.823.48 7.823s.468 3.331 1.907 4.798c1.827 1.926 4.225 1.866 5.293 2.067C11.52 40.885 24 41 24 41s10.086-.015 16.803-.505c.938-.113 2.983-.122 4.809-2.048 1.439-1.467 1.908-4.798 1.908-4.798s.48-3.91.48-7.823v-3.668c0-3.911-.48-7.824-.48-7.824Z",
    fill: "#909495"
  })));
};
export default SvgYoutube;